import React from 'react';
import PageHeader from 'components/PageHeader';
import { useBlogPageData } from 'hooks/useBlogPageData';
import ContainerLayout from 'layouts/ContainerLayout';
import ErrorLayout from 'layouts/ErrorLayout';
import LoadingLayout from 'layouts/LoadingLayout';
import BlogCard from 'pages/Blog/BlogCard';

import { Box } from '@mui/material';

import { IMediumArticle } from './Blog.types';

const Blog: React.FunctionComponent = () => {
  const { data, error, loading } = useBlogPageData();

  return (
    <ContainerLayout>
      <PageHeader>Blog</PageHeader>
      <LoadingLayout loading={loading}>
        <ErrorLayout data={data} error={error}>
          <Box>
            {data &&
              data.items.map((item: IMediumArticle) => (
                <BlogCard key={item.guid} article={item} />
              ))}
          </Box>
        </ErrorLayout>
      </LoadingLayout>
    </ContainerLayout>
  );
};

export default Blog;
